import React, { useState, useEffect } from "react";
import styles from "./ProductDetailsSection.module.css";
import mStyles from "./SpecificProduct.module.css";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import ExtraDetailGroup from "./ExtraDetails/ExtraDetailGroup";

function ProductDetailsSection({ product }) {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [collapsedDescription, setCollapsedDescription] = useState(true);
  const [collapsedProductDetails, setCollapsedProductDetails] = useState(true);
  const [collapsedDeliveryAndReturns, setCollapsedDeliveryAndReturns] =
    useState(true);

  // On wider screens, always expand
  const shouldCollapse = isMobile;

  const location = useLocation();

  useEffect(() => {
    // Reset collapsed states when the product changes
    setCollapsedDescription(true);
    setCollapsedProductDetails(true);
    setCollapsedDeliveryAndReturns(true);
  }, [location]);

  return (
    <div className={styles.ProductDetailsSection}>
      <div className={styles.ProductDescription}>
        <section>
          <header
            className={mStyles.Title}
            style={{ cursor: shouldCollapse ? "pointer" : "default" }}
            onClick={
              shouldCollapse
                ? () => setCollapsedDescription((c) => !c)
                : undefined
            }
          >
            Product Description
            {shouldCollapse && (
              <span style={{ marginLeft: 8 }}>
                {collapsedDescription ? "▼" : "▲"}
              </span>
            )}
          </header>
          {(!shouldCollapse || !collapsedDescription) && (
            <div>{product.Description}</div>
          )}
        </section>
      </div>
      {product.ExtraDetails && product.ExtraDetails.length > 0 && (
      <div className={styles.ProductDetails}>
        <header
          className={mStyles.Title}
          style={{ cursor: shouldCollapse ? "pointer" : "default" }}
          onClick={
            shouldCollapse
              ? () => setCollapsedProductDetails((c) => !c)
              : undefined
          }
        >
          Product Details
          {shouldCollapse && (
            <span style={{ marginLeft: 8 }}>
              {collapsedProductDetails ? "▼" : "▲"}
            </span>
          )}
        </header>
        {(!shouldCollapse || !collapsedProductDetails) && (
          <>
            {product.ExtraDetails && product.ExtraDetails.length > 0 ? (
              <div className={styles.ExtraDetails}>
                <ul>
                {product.ExtraDetails.map((detail, index) => (
                  <li key={index}>
                {detail.Details && detail.Details.length > 0 && (
                    <ExtraDetailGroup key={index} ExtraDetail={detail} />
                  )}
                  </li>
                ))}
                </ul>
              </div>
            ) : null}            
          </>
        )}
      </div>
      )}
      <div className={styles.DeliveryAndReturns}>
        <header
          className={mStyles.Title}
          style={{ cursor: shouldCollapse ? "pointer" : "default" }}
          onClick={
            shouldCollapse
              ? () => setCollapsedDeliveryAndReturns((c) => !c)
              : undefined
          }
        >
          Delivery & Returns
          {shouldCollapse && (
            <span style={{ marginLeft: 8 }}>
              {collapsedDeliveryAndReturns ? "▼" : "▲"}
            </span>
          )}
        </header>
        {(!shouldCollapse || !collapsedDeliveryAndReturns) && (
          <ul>
            <li>Free island-wide delivery.</li>
            <li>Two week turnaround.</li>
            <li>Contact us for urgent orders.</li>
            <li>Overseas shipping, price discussed before payment.</li>
            <li>Collections available during pop-up events.</li>
            <li>Personalised items are non-refundable, unless faulty.</li>
          </ul>
        )}
      </div>
    </div>
  );
}

export default ProductDetailsSection;
